interface SVGProps {
  style: React.CSSProperties;
  color: string;
}

const SVG = (props: SVGProps) => {
  const { color } = props;

  return (
    <svg style={props.style} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 5.24993V36.7499C8.75 38.1345 10.2817 38.9707 11.4463 38.222L35.9463 22.472C37.0179 21.7831 37.0179 20.2167 35.9463 19.5279L11.4463 3.77787C10.2817 3.02917 8.75 3.86539 8.75 5.24993ZM31.7637 21L12.2499 33.5446V8.45546L31.7637 21Z"
        fill={color}
      />
    </svg>
  );
};

export default SVG;
